import { render, staticRenderFns } from "./Votacao.vue?vue&type=template&id=0a0f9673&scoped=true&"
import script from "./Votacao.vue?vue&type=script&lang=js&"
export * from "./Votacao.vue?vue&type=script&lang=js&"
import style0 from "./Votacao.vue?vue&type=style&index=0&id=0a0f9673&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0f9673",
  null
  
)

export default component.exports